<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <img src="/assets/images/loader.svg">
        <span class="loading-message"></span>
    </div>
</div>